module.exports = __webpack_public_path__ + "img/loading.d2756d0a.svg";